import { ButtonLink } from "./button-link";

interface EmptyStateProps {
  description: string;
  title: string;
}

export function EmptyState({ description, title }: EmptyStateProps) {
  return (
    <section className="state-card" aria-labelledby="empty-state-title">
      <p className="eyebrow">Nothing here yet</p>
      <h2 id="empty-state-title">{title}</h2>
      <p>{description}</p>
    </section>
  );
}

export function LoadingState() {
  return (
    <section className="state-card" aria-live="polite" aria-busy="true">
      <span className="loading-indicator" aria-hidden="true" />
      <p>Loading your private workspace…</p>
    </section>
  );
}

export function ErrorState() {
  return (
    <main id="main-content" className="state-page">
      <section className="state-card" role="alert">
        <p className="eyebrow">Something went wrong</p>
        <h1>We could not open this page</h1>
        <p>No information was changed. Refresh the page or return to the public home.</p>
        <ButtonLink to="/">Return home</ButtonLink>
      </section>
    </main>
  );
}

export function NotFoundState() {
  return (
    <main id="main-content" className="state-page">
      <section className="state-card">
        <p className="eyebrow">Page not found</p>
        <h1>This page does not exist</h1>
        <p>The address may be incomplete or the page may have moved.</p>
        <ButtonLink to="/">Return home</ButtonLink>
      </section>
    </main>
  );
}
